import api from './api.jsx';

export const rolePermissionsAPI = {
  getRoles: () => api.get('/admin/roles-v2'),
  
  getRole: (role) => api.get(`/admin/roles-v2`).then((response) => {
    const roles = Array.isArray(response.data) ? response.data : [];
    const target = roles.find(item => String(item.role || '').toLowerCase() === String(role || '').toLowerCase());
    return {
      ...response,
      data: target || { role, permissions: [] }
    };
  }),
  
  updateRolePermissions: (role, permissions) =>
    api.put(`/admin/roles-v2/${role}/permissions`, { permissions }),
  
  createRole: (role, permissions) =>
    api.put(`/admin/roles-v2/${role}/permissions`, { permissions }),
  
  deleteRole: (role) =>
    api.delete(`/admin/roles-v2/${role}`),
  
  getAvailableTabs: () => api.get('/admin/permissions')
};
